import React from 'react';
import { Entry, HistoricalVisit } from '../types';
import HistoricalVisitList from './HistoricalVisitList';
import { ListPagination } from '../../../common';

interface HistoricalVisitsViewProps {
  historicalVisits: HistoricalVisit[];
  expandedVisit: string | number | null;
  handleExpandVisit: (visit: HistoricalVisit) => void;
  selectedVisitId: string | number;
  historicalVisitEntries: Record<string, Entry[]>;
  handleAddEntry: (type: string, visitId?: string | number) => void;
  isMobile: boolean;
  isAddingNewEntry: boolean;
  renderEntryContent: (entry: Entry) => React.ReactNode;
  renderSelectedForm: (entryId: number | string) => React.ReactNode;
  handleEditEntry: (entry: Entry) => void;
  handleFlagEntry: (entryId: string | number) => void;
  handleInvalidateEntry: (entryId: string | number) => void;
  inPlaceEditingEntryId: string | number | null;
  setInPlaceEditingEntryId: (id: string | number | null) => void;
  cancelInPlaceEdit: () => void;
  handleSaveInPlaceEdit: (entryId: string | number) => void;
  refreshHistoricalData: () => void;
  onNewChartClick: () => void;
  hasActiveVisit: boolean;
  loadingVisits?: boolean;
  hasMoreVisits?: boolean;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  loadingMoreVisits?: boolean;
}

const HistoricalVisitsView: React.FC<HistoricalVisitsViewProps> = ({
  historicalVisits,
  expandedVisit,
  handleExpandVisit,
  selectedVisitId,
  historicalVisitEntries,
  handleAddEntry,
  isMobile,
  isAddingNewEntry,
  renderEntryContent,
  renderSelectedForm,
  handleEditEntry,
  handleFlagEntry,
  handleInvalidateEntry,
  inPlaceEditingEntryId,
  setInPlaceEditingEntryId,
  cancelInPlaceEdit,
  handleSaveInPlaceEdit,
  refreshHistoricalData,
  onNewChartClick,
  hasActiveVisit,
  loadingVisits = false,
  hasMoreVisits = false,
  currentPage,
  totalPages,
  onPageChange,
  loadingMoreVisits = false
}) => {
  return (
    <div>
      {loadingVisits ? (
        <div className="flex justify-center py-8">
          <div className="text-slate-500">Loading visits...</div>
        </div>
      ) : historicalVisits.length === 0 ? (
        <div className="text-center py-8 text-slate-500">
          No historical visits found.
        </div>
      ) : (
        <HistoricalVisitList
          historicalVisits={historicalVisits}
          handleExpandVisit={handleExpandVisit}
          isMobile={isMobile}
        />
      )}

      {(hasMoreVisits || totalPages > 1) && (
        <ListPagination
          mode="pagination"
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          loading={loadingMoreVisits}
        />
      )}
    </div>
  );
};

export default HistoricalVisitsView;
